//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
export default {
  name: 'PartitionValidationErrors',
  props: {
    validation: {
      type: Object,
      required: true
    }
  },
  computed: {
    geminiMeta: function geminiMeta() {
      return this.validation.gemini_meta || {};
    },
    summary: function summary() {
      return this.geminiMeta.summary_es || '';
    },
    normalizedErrors: function normalizedErrors() {
      var _this = this;
      var errors = Array.isArray(this.validation.errors) ? this.validation.errors : [];
      var evaluated = Array.isArray(this.geminiMeta.tables_evaluated) ? this.geminiMeta.tables_evaluated : [];
      var missing = Array.isArray(this.geminiMeta.missing_filters) ? this.geminiMeta.missing_filters : [];
      return errors.map(function (err) {
        var table = err.table || '';
        var evalMeta = evaluated.find(function (e) {
          return e.table === table;
        }) || {};
        var missMeta = missing.find(function (m) {
          return m.table === table;
        }) || {};
        var line = evalMeta.line_number || (Array.isArray(missMeta.appears_in_sql_at_lines) ? missMeta.appears_in_sql_at_lines[0] : null);
        var partitionColumns = Array.isArray(err.expected_columns) ? err.expected_columns.join(', ') : evalMeta.partition_column || missMeta.expected_column || '';
        return {
          table: table,
          reason: err.reason || '',
          partitionColumns: partitionColumns,
          line: line || null,
          snippet: evalMeta.snippet || '',
          why: err.detail || missMeta.reason_es || _this.fallbackWhy(err),
          suggestion: err.suggestion || missMeta.suggestion_es || ''
        };
      });
    }
  },
  methods: {
    fallbackWhy: function fallbackWhy(err) {
      if (err.reason === 'tabla_fuera_de_bd') {
        return this.$t('create_attribute.partition_validation.outside_db', {
          table: err.table,
          expected: err.expected
        });
      }
      if (err.reason === 'script_no_filtra_particion') {
        return this.$t('create_attribute.partition_validation.missing_filter', {
          table: err.table,
          cols: Array.isArray(err.expected_columns) ? err.expected_columns.join(', ') : ''
        });
      }
      return err.reason ? "".concat(err.table, ": ").concat(err.reason) : '';
    },
    copy: function copy(text) {
      var _this2 = this;
      var onCopied = function onCopied() {
        return tasks.toast.success(_this2.$t('create_attribute.partition_validation.copied'));
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onCopied).catch(function () {
          return _this2.fallbackCopy(text, onCopied);
        });
      } else {
        this.fallbackCopy(text, onCopied);
      }
    },
    fallbackCopy: function fallbackCopy(text, onCopied) {
      var el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      onCopied();
    },
    openAllPanels: function openAllPanels() {
      var errors = this.validation && Array.isArray(this.validation.errors) ? this.validation.errors : [];
      this.allPanels = errors.map(function (_, i) {
        return i;
      });
    }
  },
  data: function data() {
    return {
      // Mantener todos los paneles abiertos por defecto: el usuario debe leer cada error.
      allPanels: []
    };
  },
  watch: {
    validation: {
      deep: true,
      handler: function handler() {
        this.openAllPanels();
      }
    }
  },
  created: function created() {
    this.openAllPanels();
  }
};